import { Either, left, right } from "fp-ts/lib/Either";
import UserEntity, { UserType } from "../../../../domain/entities/UserEntity";
import ErrorEntity, { ErrorEntityFromError } from "../../../../domain/entities/ErrorEntity";
import di from "../../../../DependencyInjection";
import HostApi, { HostApiName } from "../../../settings/HostApi";
import UserDto from "../../../dto/UserDto";

const UpdateUserApiImpl = async (_: { user: UserEntity, password?: string }): Promise<Either<ErrorEntity, UserEntity>> => {
    try {
        const relativeUrl = `/users/${_.user.id}`;
        const body = UserDto.toJson(_.user);
        
        // Solo agregar password si se proporciona
        if (_.password) {
            body.password = _.password;
        }
        
        const response = await di.get<HostApi>(HostApiName).put(relativeUrl, body, {
            contentType: "application/json",
        });

        const parsed: UserEntity = UserDto.fromJSON(response.data);
        return right(parsed);
    } catch (error) {
        return left(ErrorEntityFromError(error));
    }
}

export default UpdateUserApiImpl;